import ToolTipArrow from './ToolTipArrow'

export default ToolTipArrow
// eslint-disable-next-line import/export
export * from './ToolTipArrow'
